/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, FlexContainer, Input, theme } from "@nordcloud/gnui";
import { isNotEmpty } from "~/tools";

type Props = {
  inputMetadata?: string[];
  onChange: (tags: string[]) => void;
};

enum KEY_VALUE {
  KEY,
  VALUE,
}

const emptyTag = ["", ""];

export function MultiMetadataInput({ inputMetadata, onChange }: Props) {
  const [metadataTags, setMetadataTags] = React.useState<string[][]>(
    inputMetadata?.map((tag) => tag.split(",")) ?? []
  );

  const onChangeHandler = (value: string, index: number, field: KEY_VALUE) => {
    const newTags = [...metadataTags];
    newTags[index].splice(field, 1, value);
    setMetadataTags(newTags);
    onChange(mapTags(newTags));
  };

  const onRemoveTagHandler = (index: number) => {
    const newTags = [...metadataTags];
    newTags.splice(index, 1);
    setMetadataTags(newTags);
    onChange(mapTags(newTags));
  };

  return (
    <>
      {metadataTags?.map((tag, index) => (
        <FlexContainer
          key={index}
          alignItems="center"
          marginBottom={theme.spacing.spacing02}
          columnGap={theme.spacing.spacing02}
        >
          <Input
            value={tag[KEY_VALUE.KEY] ?? ""}
            onChange={({ target }) =>
              onChangeHandler(target.value, index, KEY_VALUE.KEY)
            }
          />
          <Input
            name={tag[KEY_VALUE.KEY] ?? ""}
            value={tag[KEY_VALUE.VALUE] ?? ""}
            onChange={({ target }) =>
              onChangeHandler(target.value, index, KEY_VALUE.VALUE)
            }
          />
          <Button
            severity="low"
            icon="trash"
            onClick={() => onRemoveTagHandler(index)}
          />
        </FlexContainer>
      ))}
      <Button
        severity="low"
        onClick={() => setMetadataTags([...metadataTags, [...emptyTag]])}
      >
        Add Metadata
      </Button>
    </>
  );
}

function mapTags(tags: string[][]) {
  return tags
    .filter((tag) => isNotEmpty(tag.join("")))
    .map((tag) => tag.join(","));
}
